/**
 * Where an invite token becomes a URL a human can click.
 *
 * Invite links use a QUERY PARAM, not a path.
 *
 * The app has no router, and it is served by Vite behind a reverse proxy — so
 * a clean `/invite/<token>` path would depend on an SPA fallback rewrite that
 * is not configured for the app host in `deploy/Caddyfile`. A query param
 * works on any static server with no routing config at all, which matters
 * enormously for the one link the whole onboarding depends on.
 *
 * This lives in `lib/` rather than next to a view because there are now three
 * callers: the launch wizard's success screen, its CSV export, and Admin →
 * Users' re-invite. It used to be defined inside `CampaignSetupView`, and the
 * CSV export — thirty lines below the definition and below the comment above —
 * hand-rolled `${base}/invite/${token}` instead. Every link a manager
 * distributed from that CSV 404'd. One formatter, every caller: the same
 * reason `lib/roles.ts` exists.
 */

/** The URL an invitee opens to set their password. `origin` has no trailing slash. */
export function inviteUrl(origin: string, token: string): string {
  return `${origin}/?invite=${encodeURIComponent(token)}`;
}
